module.exports = __webpack_public_path__ + "static/media/groupPardini.c430260c.svg";